import { render, staticRenderFns } from "./term.vue?vue&type=template&id=6d6de6e4&scoped=true"
import script from "./term.vue?vue&type=script&lang=js"
export * from "./term.vue?vue&type=script&lang=js"
import style0 from "./term.vue?vue&type=style&index=0&id=6d6de6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6de6e4",
  null
  
)

export default component.exports